import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from '@mui/material/CircularProgress';
import { useAppSelector, useAppDispatch } from "../../hooks";
import { selectLock, selectGates, handleLockUnlockAsync, lockDoorAsync } from './store/locksSlicer'

import { ScenesItem, Icons, FloorItem, AvatarStyle } from './style'
import { doorType, } from './store/types'

import './index.css'
const Locks = () => {

  const dispatch = useAppDispatch();

  const Floors = useAppSelector(selectGates)
  const locksState = useAppSelector(selectLock)


  const handleLocks = (door: doorType) => {
    dispatch(lockDoorAsync(door.id))
  }

  const handleLockAll = () => {
    dispatch(handleLockUnlockAsync(true))
  }
  const handleUnlockAll = () => {
    dispatch(handleLockUnlockAsync(false))
  }
  return (
    <Container maxWidth="lg">

      <Grid container spacing={4} sx={{ mt: 4 }} >
        <Grid sm={12} md={12}>
          <Typography
            variant="body1"
            sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
          >
            SCENES
          </Typography>
        </Grid>

        <Grid container md={12} spacing={{ md: 2 }}>
          <Grid md={3}>
            <ScenesItem onClick={handleLockAll}>
              <Avatar sx={AvatarStyle} src={Icons.YellowLock} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Lock All</Typography>
            </ScenesItem>
          </Grid>
          <Grid md={3}>
            <ScenesItem onClick={handleUnlockAll}>
              <Avatar sx={AvatarStyle} src={Icons.YellowUnLock} />
              <Typography variant="body1" sx={{ fontSize: 18 }}>Unlock All</Typography>
            </ScenesItem>
          </Grid>
        </Grid>
      </Grid>

      {
        Floors.map((ele, index) => {
          return (
            <Grid key={index} container spacing={4} sx={{ mt: 4 }} >
              <Grid ip={12} md={12}>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400, color: "#909090" }}
                >
                  FLOOR {ele.floor}
                </Typography>
              </Grid>

              {locksState.loading ?
                <Grid container md={12} spacing={{ md: 2 }}>
                  {
                    ele.doors.map((f, i) => {
                      return (
                        <Grid key={i} md={3} >
                          <FloorItem id={f.id.toString()} onClick={() => handleLocks(f)}>

                            <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} />
                            <div className="floors-text">
                              <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{f.name} </Typography>
                              <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}>Loading... </Typography>
                            </div>
                          </FloorItem>
                        </Grid>
                      )
                    })
                  }
                </Grid>
                :
                <Grid container md={12} spacing={{ md: 2 }}>
                  {
                    ele.doors.map((f, i) => {
                      return (
                        <Grid key={i} md={3} >
                          <FloorItem id={f.id.toString()} onClick={() => handleLocks(f)}>

                            {locksState.doorLoading && locksState.selectedGate === f.id ? <CircularProgress size={20} color='inherit' sx={{ width: 31, height: 31, fontSize: 12, marginLeft: "15px" }} /> : <Avatar sx={{ width: 31, height: 31, marginLeft: "15px" }} src={f.isLocked ? Icons.WhiteLock : Icons.YellowUnLock} />}
                            <div className="floors-text">
                              <Typography variant="body1" sx={{ fontSize: 18, textTransform: "capitalize" }}>{f.name} </Typography>
                              {locksState.doorLoading && locksState.selectedGate === f.id ? <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}>Loading... </Typography> :
                                <Typography variant="body1" sx={{ fontSize: 14, color: "#909090" }}>{f.isLocked ? "LOCKED" : "UNLOCKED"} </Typography>
                              }
                            </div>
                          </FloorItem>
                        </Grid>
                      )
                    })
                  }

                </Grid>}


            </Grid>
          )
        })
      }


    </Container>
  );
};

export default Locks;
